import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileName'
})
export class FileNamePipe implements PipeTransform {

  transform(value: string, args?: any): string {
    if(value !=null){
       let  filename:string =value.slice(value.lastIndexOf('-')+1);
    return filename;
    }
    else{
      return null;
    }
}
}